import React, { createContext, useContext } from "react";
import bg2 from "@/assets/Backgroud image 2.jpg";

const BackgroundRotatorContext = createContext({
  currentIndex: 0,
  currentImage: bg2,
});

export const useBackgroundRotator = () => useContext(BackgroundRotatorContext);

const BackgroundRotatorProvider = ({ children }: { children: React.ReactNode }) => {
  return (
    <BackgroundRotatorContext.Provider value={{ currentIndex: 0, currentImage: bg2 }}>
      <div className="fixed inset-0 -z-50 w-full h-full overflow-hidden">
        <div
          className="absolute inset-0 w-full h-full opacity-100 bg-center bg-cover pointer-events-none"
          style={{ backgroundImage: `url(${bg2})`, backgroundSize: "cover", backgroundPosition: "center" }}
        />
        <div className="absolute inset-0 w-full h-full bg-black/50 pointer-events-none" />
      </div>
      {children}
    </BackgroundRotatorContext.Provider>
  );
};

export default BackgroundRotatorProvider; 